import './counter.scss';

class Counter {
    constructor (element) {
        this.element = element;
        this.allCounters = this.element.querySelectorAll('[data-counter="counter"]');
        this.startTimestamp = null;
        this.startValue = 0;
    }

    initialize () {
        this.allCounters.forEach(counter => {
            const textContent = counter.innerText.trim();
            const endValue = parseInt(textContent);

            if (!isNaN(endValue)) {
                const duration = 1200;
                const secondstart = 0.80;
                const endduration = 2700;
                counter.innerText = '0';

                const observer = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (entry.isIntersecting) {
                            window.requestAnimationFrame((timestamp) => this.countUp(timestamp, counter, endValue, duration, secondstart, endduration, counter.parentElement));
                        }
                    }
                });
                observer.observe(counter);
            }
        });
    }

    countUp (timestamp, el, endValue, duration, secondstart, endduration, parentElement) {
        if (!this.startTimestamp) this.startTimestamp = timestamp;
        const progress = Math.min((timestamp - this.startTimestamp) / duration, 1);
        const value = Math.floor(progress * (endValue - this.startValue) + this.startValue);

        // Update the text content of the element with the animated value
        el.textContent = this.addThousandSeparator(value);

        if (progress > secondstart) {
            this.duration = endduration;
        }

        if (progress < 1) {
            window.requestAnimationFrame((timestamp) => this.countUp(timestamp, el, endValue, duration, secondstart, endduration, parentElement));
        } else {
            parentElement.classList.add('counter__item--done');
        }
    }

    addThousandSeparator (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}

export { Counter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $counters = $context.querySelectorAll('[data-counter="root"]');

        for (let i = 0; i < $counters.length; i++) {
            const $counter = new Counter($counters[i]);
            $counter.initialize();
        }
    }
});
